@if (helpdeskButtons(); as helpdeskButtons) {
<div class="push-bottom">
	<lib-button-list [buttons]="helpdeskButtons"></lib-button-list>
</div>
}

<div [libFlexRow]="isMobileView()" [libFlexRowAlign]="'start'">
	<div libFlexColumn [libFlexSize]="'fill'">
		@if (userListItems(); as userListItems) {
		<lib-card [title]="'Helpdesk conversations'">
			<lib-list
				[disableSort]="true"
				[avatarSize]="'50px'"
				[enableSearch]="true"
				[design]="'selectionList'"
				[showNameBasedAvatar]="true"
				[items]="userListItems"
				[noItemsText]="'There are no helpdesk conversations'"
			></lib-list>
		</lib-card>
		}
	</div>
</div>
